import { Button, ButtonProps, Icon } from '@cue/atoms';
import { useHash } from '@cue/hooks';
import { MenuItemData } from '@cue/molecules';
import { useLivestreamStatus } from '@project/hooks/use-livestream-status';
import { Link } from 'gatsby';
import { MenuItemWaypoint } from './menu-item-waypoint';

interface MenuItemDataExtended {
  iconAlign?: ButtonProps['iconAlign'];
  custom_action?: string;
  livestream_indicator?: boolean;
  onCustomAction?(custom_action: string): void;
  onClick?(): void;
  additionalIcon?: string;
}

export const MenuItem: React.FC<MenuItemDataExtended & MenuItemData> = ({
  label,
  link,
  icon,
  livestream_indicator,
  iconAlign = 'left',
  isActive,
  custom_action,
  onCustomAction,
  onClick,
  target,
  custom,
  additionalIcon,
}) => {
  const { hash } = useHash();
  const { isLive } = useLivestreamStatus() || { isLive: false };

  const ariaLabel = !label ? 'Home' : label ? label : 'menu-item';

  const navItem = (
    <Button
      styling="menuItem"
      icon={livestream_indicator && isLive ? 'live' : icon || undefined}
      iconAlign={iconAlign}
      data-test-id={custom_action}>
      {label}
      {additionalIcon && <Icon name={additionalIcon} />}
    </Button>
  );
  if (custom_action) {
    return (
      <a
        onClick={(e) => {
          e.preventDefault();
          onCustomAction && onCustomAction(custom_action);
        }}
        className={link === hash ? 'active' : ''}
        target={target || undefined}
        aria-label={ariaLabel}>
        {navItem}
      </a>
    );
  }

  if (custom?.as_hash) {
    return (
      <MenuItemWaypoint
        link={link}
        label={ariaLabel}
        navItem={navItem}
        onClick={() => onClick && onClick()}
      />
    );
  }

  if (target) {
    return (
      <a href={link || ''} target={target || undefined} aria-label={ariaLabel}>
        {navItem}
      </a>
    );
  }

  return (
    <a
      /* to={link || '/'} */
      aria-label={ariaLabel}
/*       activeClassName="active"
 */      className={isActive ? "active" : ""}
      onClick={() => {
        onClick && onClick();
        document.location.href = link || '/';
      }}
/*       partiallyActive={isActive} */>
      {navItem}
    </a>
  );
};
